import React, { useState, useEffect } from "react";

import Visa from "../images/visa.png";
import Mastercard from "../images/mastercard.png";
import Discover from "../images/discover.png";
import Amex from "../images/amex.png";

import CardIcon from "@material-ui/icons/CreditCard";

var creditcardutils = require("creditcardutils");

const CardInput = (props) => {
  const [cardNumber, setCardNumber] = useState("");
  const [cardIsValid, setCardIsValid] = useState(true);
  const [cardType, setCardType] = useState(null);

  useEffect(() => {
    setCardType(props.cardType);
  }, [props.cardType]);

  function validateCardNumber(value) {
    var formattedNumber = creditcardutils.formatCardNumber(value);
    var cardValidated = creditcardutils.validateCardNumber(value);
    var cardType = creditcardutils.parseCardType(value);

    if (
      cardValidated &&
      (value.replace(/ /g, "").length === 16 ||
        value.replace(/ /g, "").length === 15 ||
        value.replace(/ /g, "").length === 19)
    ) {
      return {
        cardNumber: formattedNumber,
        cardValidated: true,
        cardType,
      };
    } else {
      return {
        cardNumber: formattedNumber,
        cardValidated: false,
        cardType,
      };
    }
  }

  function setCardValue(cardNumber) {
    //console.log(props.cardNumber.length);
    const cardInfo = validateCardNumber(cardNumber);

    props.setCardNumber
      ? props.setCardNumber(cardInfo.cardNumber)
      : setCardNumber(cardInfo.cardNumber);
    props.setCardIsValid
      ? props.setCardIsValid(cardInfo.cardValidated)
      : setCardIsValid(cardInfo.cardValidated);
    props.setCardType
      ? props.setCardType(cardInfo.cardType)
      : setCardType(cardInfo.cardType);
    setCardIsValid(cardInfo.cardValidated);
  }

  function renderCardType(type) {
    switch (type) {
      case "visa":
        return <img src={Visa} height={20} />;
      case "discover":
        return <img src={Discover} height={20} />;
      case "mastercard":
        return <img src={Mastercard} height={20} />;
      case "amex":
        return <img src={Amex} height={20} />;
      default:
        return <CardIcon style={{ fontSize: 25 }} />;
    }
  }

  return (
    <div style={{ width: "100%" }}>
      <label
        style={{
          color: "#2f343b",
          display: "flex",
          alignSelf: "flex-start",
          marginBottom: 8,
        }}
      >
        <x-lang>Card Number</x-lang>
      </label>
      <div
        style={{
          height: 40,
          width: "100%",
          borderRadius: 6,
          flexDirection: "row",
          display: "flex",
          border: cardIsValid ? "1px solid #d3dce0" : "1px solid red",
          boxShadow: "inset 0px 0px 0px 0px",

          borderStyle: "solid",
          alignItems: "center",
          marginBottom: 25,
          boxSizing: "border-box",
          textTransform: "lowercase",
          paddingRight: 10,
          paddingLeft: 10,
        }}
      >
        {renderCardType(cardType)}
        <input
          type="text"
          value={props.cardNumber ? props.cardNumber : cardNumber}
          onChange={(e) => {
            setCardValue(e.target.value);
          }}
          id="intellipay-card-number"
          maxLength={
            cardIsValid && cardNumber.length > 1
              ? props.cardNumber.length - 1
              : 19
          }
          style={{
            height: "100%",
            width: "100%",
            boxSizing: "border-box",
            border: "none",
            padding: 0,
            paddingLeft: 8,
            borderRadius: 6,
            fontSize: "1rem",
            fontWeight: 400,
            outline: "none",
          }}
        />
      </div>
    </div>
  );
};

export default CardInput;
